import axios from "axios";

import { MAIN_API } from "../../../config/stepoutAPI";
import { IS_LOGOUT } from "../types";
import {
  ASSIGN_ORGANIZER_MATCH_RESPONSE,
  FETCHING_ANALYST_DONE,
  FETCHING_ANALYST_REQUEST,
  FETCHING_MATCHES_DONE,
  FETCHING_MATCHES_REQUEST,
  FETCHING_ORGANIZER_DONE,
  FETCHING_ORGANIZER_REQUEST,
  GET_ANALYST_LIST_RESPONSE,
  GET_MATCHES_LIST_RESPONSE,
  GET_ORGANIZER_LIST_RESPONSE,
  UPDATING_ANALYST_DONE,
  UPDATING_ANALYST_REQUEST,
  UPDATING_PORT_DONE,
  UPDATING_PORT_REQUEST,
} from "./types";
import { decryptResponse } from "../../../utils/decryptData";

export const getAllMatches = ({ token }) => {
  return async (dispatch) => {
    dispatch({ type: FETCHING_MATCHES_REQUEST });
    try {
      const response = await axios({
        method: "post",
        url: `${MAIN_API}getAllMatches/v2/`,
        data: {
          source: "analyst_portal",
          hashed_required: true,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const payload = decryptResponse(response?.data?.response_data, true);
        dispatch({ type: FETCHING_MATCHES_DONE });
        dispatch({
          type: GET_MATCHES_LIST_RESPONSE,
          payload,
        });
      } else {
        dispatch({ type: FETCHING_MATCHES_DONE });
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: IS_LOGOUT });
      }
      dispatch({ type: FETCHING_MATCHES_DONE });
      console.log("error:", error);
    }
  };
};

export const getAllAnalyst = ({ token }) => {
  return async (dispatch) => {
    dispatch({ type: FETCHING_ANALYST_REQUEST });
    try {
      const response = await axios({
        method: "get",
        url: `${MAIN_API}overall_analyst_data/v2`,

        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const response_data = response?.data?.response_data;
        // decryptResponse(
        //   response?.data?.response_data,
        //   true
        // );
        const payload = response_data?.match_data;
        dispatch({ type: FETCHING_ANALYST_DONE });
        dispatch({
          type: GET_ANALYST_LIST_RESPONSE,
          payload,
        });
      } else {
        dispatch({ type: FETCHING_ANALYST_DONE });
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: IS_LOGOUT });
      }
      console.log("error:", error);
    }
  };
};

export const getAllOrganizer = ({ token }) => {
  return async (dispatch) => {
    dispatch({ type: FETCHING_ORGANIZER_REQUEST });
    try {
      const response = await axios({
        method: "get",
        url: `${MAIN_API}overall_organizer_data?hashed_required=true`,

        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const payload = decryptResponse(response?.data?.response_data, true);
        dispatch({ type: FETCHING_ORGANIZER_DONE });
        dispatch({
          type: GET_ORGANIZER_LIST_RESPONSE,
          payload,
        });
      } else {
        dispatch({ type: FETCHING_ORGANIZER_DONE });
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: IS_LOGOUT });
      }
      console.log("error:", error);
    }
  };
};

export const portMatch = ({ token, data }) => {
  return async (dispatch) => {
    dispatch({ type: UPDATING_PORT_REQUEST });
    try {
      const response = await axios({
        method: "post",
        url: `${MAIN_API}port_entity/`,
        data: {
          ...data,
          // hashed_required: true,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const payload = response?.data?.response_data;
        dispatch({
          type: ASSIGN_ORGANIZER_MATCH_RESPONSE,
          payload,
        });
        dispatch({ type: UPDATING_PORT_DONE });
      } else {
        dispatch({ type: UPDATING_PORT_DONE });
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: IS_LOGOUT });
      }
      console.log("error:", error);
    }
  };
};

export const assignAnalyst = ({ token, data }) => {
  return async (dispatch) => {
    dispatch({ type: UPDATING_ANALYST_REQUEST });
    try {
      const response = await axios({
        method: "post",
        url: `${MAIN_API}assign_analyst_match/v2/`,
        data: {
          ...data,
          hashed_required: true,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const payload = decryptResponse(response?.data?.response_data, true);
        dispatch({
          type: ASSIGN_ORGANIZER_MATCH_RESPONSE,
          payload,
        });
        dispatch({ type: UPDATING_ANALYST_DONE });
      } else {
        dispatch({ type: UPDATING_ANALYST_DONE });
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: IS_LOGOUT });
      }
      console.log("error:", error);
    }
  };
};
